import React, { Component } from 'react';

import { Marker } from 'google-maps-react';

import portalPoleBlueIcon from '../../../images/poleIcons/blue/03.svg';
import portalPoleGreenIcon from '../../../images/poleIcons/green/03.svg';
import portalPoleYellowIcon from '../../../images/poleIcons/yellow/03.svg';
import portalPoleOrangeIcon from '../../../images/poleIcons/orange/03.svg';
import portalPoleRedIcon from '../../../images/poleIcons/red/03.svg';


class PortalsList extends Component {

    componentDidMount = () => {
        this.loadPortals();
    }

    shouldComponentUpdate(nextProps) {
        
        if(!this.comparePortalLists(this.props.ohlsList, nextProps.ohlsList) 
            || this.props.zoomLevel !== nextProps.zoomLevel 
            || this.props.poleSize !== nextProps.poleSize
            || this.props.showPortalsAlways !== nextProps.showPortalsAlways
            || this.props.showLargeIcons !== nextProps.showLargeIcons
            || this.props.showHealthIndexes !== nextProps.showHealthIndexes){
            return true;
        }
        else{
            return false; 
        }
    }

    comparePortalLists = (list1, list2) => {
        ////NOTE: deep compare is needed
        if(list1.length !== list2.length){
            return false;
        }
        return true;
    }

    componentDidUpdate = () => {
        this.loadPortals();
    }

    loadPortals = () => {
        let resultList = [];
        const portalsList = this.filterPortals(this.props.ohlsList);
        if((this.props.showPortalsAlways /*&& this.props.zoomLevel < 2*/ && this.props.zoomLevel > 0) || this.props.zoomLevel >= 2) {
            resultList = portalsList.map((portal, index) => {
                let poleIcon = portalPoleBlueIcon;
                if (this.props.showHealthIndexes) {
                    switch (portal.pole.healthIndex) {
                        case 'red': poleIcon = portalPoleRedIcon; break;
                        case 'orange': poleIcon = portalPoleOrangeIcon; break;
                        case 'yellow': poleIcon = portalPoleYellowIcon; break;
                        default: poleIcon = portalPoleGreenIcon; break;
                    }
                }
                return <Marker
                    options={{ icon: { url: poleIcon, scaledSize: { width: this.props.poleSize, height: this.props.poleSize } } }}
                    key={'Portal ' + index}
                    onClick={this.props.onPortalClick}
                    position={{ lat: portal.pole.lat, lng: portal.pole.lng }}
                    title={'OHL: ' + portal.ohlName  + ' Name: ' + portal.pole.name}
                    ohlName={portal.ohlName}
                    poleName={portal.pole.name}
                    poleItemIndex={portal.pole.index}
                />
            })
        }

        this.props.sendChildElementDataToState(this.props.stateElementName, resultList);
    }

    filterPortals = (ohlsList) => {

        let portalsList = [];

        ohlsList.forEach(ohl => {
            portalsList = portalsList.concat(ohl.stubovi.filter(pole => pole.portal).map(pole => ({pole: pole, ohlName: ohl.name })));
        });

        // if(bounds){
        //     portalsList = portalsList.filter(p =>
        //         p.pole.lat >= this.state.bounds.latMin
        //         && p.pole.lat <= this.state.bounds.latMax
        //         && p.pole.lng >= this.state.bounds.lngMin
        //         && p.pole.lng <= this.state.bounds.lngMax
        //     );
        // }

        return portalsList;
    }

    render() {
        return null
    }
}




export default PortalsList;